import { Outlet } from "react-router-dom";
import AuthFooter from "../common/AuthFooter/AuthFooter";
import AuthHeader from "../common/AuthHeader/AuthHeader";

const AuthLayout = (props) => {
    return (
        <>
            <AuthHeader />
            <div className="AuthCntLd">

                <Outlet />

            </div>
            <AuthFooter />
        </>
    );
}
export default AuthLayout;
